const FirstFoldImages = (preloadFirstFoldImages) => (
  <>
    {preloadFirstFoldImages?.map((image, index) => (
      <link key={`${image?.src}${index}`} rel="preload" href={image?.src} as="image" />
    ))}
  </>
);

export default FirstFoldImages;
